export enum OrderAddressTypeEnum {
    SOURCE = 'source',
    TARGET = 'target',
    NONE = 'none',
}